import React, { useState, useEffect, useRef } from "react";
// import { createTheme } from "@mui/material/styles";
import { AppSingleton } from "../services/user_config";
import { Grid, Slide } from "@mui/material";
import JSMpeg from "jsmpeg";

const RobotStreamSection = () => {
  const theme = new AppSingleton().theme;
  // const canvas = this.refs.canvas;
  // var canvas = document.getElementById("canvas");
  const canvasRef = useRef(null);
  const url = "ws://192.168.0.220:8009";
  const [player, setPlayer] = useState(null);
  // this.setState({ player });

  useEffect(() => {
    // const _player = new JSMpeg.Player(url, { canvasRef });
    const _player = new JSMpeg(url, { canvasRef });
    setPlayer(_player);
  }, []);

  return (
    <>
      <Slide
        direction="left"
        in={true}
        mountOnEnter
        unmountOnExit
        easing={{
          enter: theme.transitions.easing.easeOut,
          exit: theme.transitions.easing.easeIn,
        }}
        timeout={1000}
      >
        <Grid container spacing={4}>
          <Grid key="player-window" item xs={12} loading="lazy">
            {/* <canvas ref="canvas" />; */}
            <canvas
              className="jsmpeg"
              id="canvas"
              ref={canvasRef}
              width="1920"
              height="1080"
            />
            {/* <script src="/jsmpeg.min.js"></script> */}
          </Grid>
        </Grid>
      </Slide>
      {/* <script src="jsmpeg.min.js"></script> */}
    </>
  );
};

const f = () => {
  return <></>;
};

export { RobotStreamSection, f };
